module.exports = __webpack_public_path__ + "static/media/grid-active.a6e18ac2.svg";